// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"avatarItem_thumbnail__2Di0-","active":"avatarItem_active__2CW57"};